import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { ModalService } from "@core-services/modal.service";
import { CoreModule } from "@modules/core/core.module";
import { AddressBookCreateWalletTypeModalComponent } from "../address-book-create-wallet-type-modal/address-book-create-wallet-type-modal.component";
import {
	AddressBookWalletModel,
	AddressBookWalletModelAsset,
	AddressBookWalletModelNetwork,
	AddressBookWalletViewType,
	OwnerType
} from "../model/address-book-wallet.model";
import { config } from "@config";

@Component({
	selector: "app-address-book-create-owner-type-modal",
	imports: [CoreModule],
	templateUrl: "./address-book-create-owner-type-modal.component.html",
	styleUrl: "./address-book-create-owner-type-modal.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddressBookCreateOwnerTypeModalComponent {
	@Input() set data({ type, wallet, accountWalletId, selectedNetwork, selectedCryptocoin, SHW3rdPartyDisabled }) {
		this.modalType = type;
		this.wallet = wallet;
		this.accountWalletId = accountWalletId;
		this.selectedNetwork = selectedNetwork;
		this.selectedCryptocoin = selectedCryptocoin;
		this.SHW3rdPartyDisabled = SHW3rdPartyDisabled;
	}

	public modalType: AddressBookWalletViewType = AddressBookWalletViewType.NEW;
	public wallet?: AddressBookWalletModel;
	public accountWalletId?: string;
	public selectedNetwork?: AddressBookWalletModelNetwork;
	public selectedCryptocoin?: AddressBookWalletModelAsset;
	public addressBookWalletViewType = AddressBookWalletViewType;
	public ownerType = OwnerType;
	public learnMoreUrl: string = config.externalPaths["travel_rule"]["faq"];
	private SHW3rdPartyDisabled: boolean;

	constructor(private readonly modalService: ModalService) {}

	public cancel(): void {
		this.modalService.popAll();
	}

	public back(): void {
		this.modalService.pop();
	}

	public selectOwnerType(ownerType: OwnerType): void {
		this.modalService.showModal(AddressBookCreateWalletTypeModalComponent, {
			type: this.modalType,
			wallet: this.wallet,
			accountWalletId: this.accountWalletId,
			selectedNetwork: this.selectedNetwork,
			selectedCryptocoin: this.selectedCryptocoin,
			ownerType: ownerType,
			SHW3rdPartyDisabled: this.SHW3rdPartyDisabled
		});
	}
}
